import _objectSpread from "/tmp/build_0e5801b9/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */

import { containerPhrasing } from 'mdast-util-to-markdown/lib/util/container-phrasing.js';
import { track } from 'mdast-util-to-markdown/lib/util/track.js';

/** @type {FromMarkdownExtension} */
export var gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {
    strikethrough: enterStrikethrough
  },
  exit: {
    strikethrough: exitStrikethrough
  }
};

/** @type {ToMarkdownExtension} */
export var gfmStrikethroughToMarkdown = {
  unsafe: [{
    character: '~',
    inConstruct: 'phrasing'
  }],
  handlers: {
    delete: handleDelete
  }
};
handleDelete.peek = peekDelete;

/** @type {FromMarkdownHandle} */
function enterStrikethrough(token) {
  this.enter({
    type: 'delete',
    children: []
  }, token);
}

/** @type {FromMarkdownHandle} */
function exitStrikethrough(token) {
  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, context, safeOptions) {
  var tracker = track(safeOptions);
  var exit = context.enter('emphasis');
  var value = tracker.move('~~');
  value += containerPhrasing(node, context, _objectSpread(_objectSpread({}, tracker.current()), {}, {
    before: value,
    after: '~'
  }));
  value += tracker.move('~~');
  exit();
  return value;
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~';
}